"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IDENTITIES_WITH_ISSUING_STATE = exports.IDENTITIES_WITH_EXPIRATION_DATE = exports.IDENTITIES_WITH_ISSUE_DATE = exports.IDENTITY_TYPES_SETS_BY_ACCOUNT_TYPE = exports.IDENTITY_TYPES_BY_ACCOUNT_TYPE = exports.IS_PII_IDENTITY = void 0;
var account_api_1 = require("@newfront-insurance/account-api");
exports.IS_PII_IDENTITY = {
    BUSINESS_IDENTIFIER: false,
    DRIVERS_LICENSE: true,
    PASSPORT: true,
    PERMANENT_RESIDENT_CARD: true,
    SSN: true,
    STATE_ID_CARD: true,
};
exports.IDENTITY_TYPES_BY_ACCOUNT_TYPE = {
    commercial: [account_api_1.IdentityType.BUSINESS_IDENTIFIER],
    personal: [
        account_api_1.IdentityType.SSN,
        account_api_1.IdentityType.PASSPORT,
        account_api_1.IdentityType.DRIVERS_LICENSE,
        account_api_1.IdentityType.PERMANENT_RESIDENT_CARD,
        account_api_1.IdentityType.STATE_ID_CARD,
    ],
};
exports.IDENTITY_TYPES_SETS_BY_ACCOUNT_TYPE = {
    commercial: new Set(exports.IDENTITY_TYPES_BY_ACCOUNT_TYPE.commercial),
    personal: new Set(exports.IDENTITY_TYPES_BY_ACCOUNT_TYPE.personal),
};
exports.IDENTITIES_WITH_ISSUE_DATE = [account_api_1.IdentityType.PASSPORT];
exports.IDENTITIES_WITH_EXPIRATION_DATE = [
    account_api_1.IdentityType.PASSPORT,
    account_api_1.IdentityType.PERMANENT_RESIDENT_CARD,
    account_api_1.IdentityType.STATE_ID_CARD,
];
exports.IDENTITIES_WITH_ISSUING_STATE = [account_api_1.IdentityType.DRIVERS_LICENSE, account_api_1.IdentityType.STATE_ID_CARD];
//# sourceMappingURL=util.js.map